/**
 * Utilidades de performance: calienta conexiones críticas y posterga
 * el trabajo no esencial hasta que el navegador esté libre.
 */

const addLink = (rel: string, href: string, as?: string) => {
  if (typeof document === 'undefined') return
  if (document.head.querySelector(`link[rel="${rel}"][href="${href}"]`)) return

  const link = document.createElement('link')
  link.rel = rel
  link.href = href
  if (as) link.as = as
  if (rel === 'preconnect' || rel === 'dns-prefetch') link.crossOrigin = ''
  document.head.appendChild(link)
}

const origin = (url: string) => {
  try {
    return new URL(url).origin
  } catch {
    return ''
  }
}

/** Precarga la imagen del hero y abre las conexiones al checkout y al CDN. */
export function warmConnections(checkoutUrl: string, heroImage: string) {
  addLink('preload', heroImage, 'image')

  const heroOrigin = origin(heroImage)
  if (heroOrigin) addLink('preconnect', heroOrigin)

  const checkoutOrigin = origin(checkoutUrl)
  if (checkoutOrigin) {
    addLink('dns-prefetch', checkoutOrigin)
    addLink('preconnect', checkoutOrigin)
  }

  addLink('preconnect', 'https://connect.facebook.net')
}

/** Ejecuta una tarea cuando el navegador está inactivo (o al poco tiempo). */
export function runWhenIdle(task: () => void, timeout = 2500) {
  if (typeof window === 'undefined') return

  const idle = (
    window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number
    }
  ).requestIdleCallback

  if (idle) {
    idle(task, { timeout })
  } else {
    window.setTimeout(task, 1200)
  }
}
